// Breadcrumb no padrão da página do imóvel (components/history/HistoryComponent.tsx, páginas 1 e 3). Não usa o
// componente: ele monta os links a partir da rota do imóvel, não preserva `?regiao=` e troca "-" por espaço
// no nome ("Xangri-Lá" → "Xangri Lá"). Os itens casam com o JSON-LD de breadcrumb da página.
import Link from 'next/link';
import { IoIosArrowForward } from 'react-icons/io';
import styles from './EmpreendimentoDetalhe.module.css';

const BreadcrumbEmpreendimento = ({
    hrefInicio,
    hrefCondominios,
    nome,
}: {
    hrefInicio: string;
    hrefCondominios: string;
    nome: string;
}) => (
    <nav className={styles.breadcrumb} aria-label="Você está em">
        <ul className={styles.breadcrumbLista}>
            <li className={styles.breadcrumbItem}>
                <Link href={hrefInicio} prefetch={false} className={styles.breadcrumbLink}>
                    Início
                    <IoIosArrowForward size={10} />
                </Link>
            </li>
            <li className={styles.breadcrumbItem}>
                <Link href={hrefCondominios} prefetch={false} className={styles.breadcrumbLink}>
                    Condomínios
                    <IoIosArrowForward size={10} />
                </Link>
            </li>
            <li className={styles.breadcrumbItem}>
                <span className={styles.breadcrumbAtual} aria-current="page">{nome}</span>
            </li>
        </ul>
    </nav>
);

export default BreadcrumbEmpreendimento;
